import { createContext, useContext, useState } from "react"
import api from "../utils/api";
import { MessageContext } from "./message";

export const DataSchoolContext = createContext();

const DataSchoolProvider = ({ children }) => {

    const [dataSchool, setDataSchool] = useState({
        "schoolName": "SISTEMA DE CARREGAMENTO",
        "theAmountClass": 190,
        "theAmountStudents": 190,
        "theAmountProfessionals": 190,
        "theAmountSchoolManager": 190,
        "inep": 40028922
    })
    const { setErrorMessage } = useContext(MessageContext);
    function getDataSchool() {
        const data = sessionStorage.getItem("inep");
        api
            .get("/dashboard/" + data)
            .then((response) => {
                console.log(response.data)
                setDataSchool(response.data);
                localStorage.setItem("dataSchool", JSON.stringify(response.data));
            })
            .catch((err) => {
                console.log(err)
                setErrorMessage([{ message: "erro ao buscar dados da escola!", ok: false }])
                setDataSchool(null);
            });
    }
    return (
        <DataSchoolContext.Provider value={{ dataSchool, setDataSchool, getDataSchool }}>
            {children}
        </DataSchoolContext.Provider>
    )
}

export default DataSchoolProvider;